import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Elezioni from './Elezioni';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<Elezioni />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js